/* SQUstore Theme JS — 2026 */
'use strict';

// === CANVAS PARTICLE SYSTEM ===
(function () {
  const canvas = document.getElementById('bgParticles');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let W, H, particles = [], raf;

  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }

  // Each particle: tiny gold speck drifting upward with a sine sway
  class Particle {
    constructor(scattered) {
      this.reset(scattered);
    }
    reset(scattered) {
      this.x      = Math.random() * W;
      this.y      = scattered ? Math.random() * H : H + Math.random() * 60;
      this.r      = Math.random() * 1.1 + .25;
      this.vy     = Math.random() * .35 + .12;   // drift upward
      this.vx     = 0;
      this.phase  = Math.random() * Math.PI * 2; // sine sway offset
      this.freq   = Math.random() * .008 + .003;  // sway speed
      this.amp    = Math.random() * .55 + .2;     // sway width (px)
      this.life   = 0;
      this.maxLife = Math.random() * 280 + 180;
      this.baseAlpha = Math.random() * .45 + .1;
      // 80% silver chrome dust, 20% dark steel specks
      this.color = Math.random() > .2
        ? `184,200,216`
        : `120,140,158`;
    }
    update() {
      this.life++;
      this.y  -= this.vy;
      this.x  += Math.sin(this.phase + this.life * this.freq) * this.amp * .06;
      if (this.life > this.maxLife || this.y < -8) this.reset(false);
    }
    draw() {
      // fade in + fade out using sine envelope
      const t     = this.life / this.maxLife;
      const alpha = this.baseAlpha * Math.sin(t * Math.PI);
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${this.color},${alpha.toFixed(3)})`;
      ctx.fill();
    }
  }

  function init() {
    resize();
    particles = Array.from({ length: 90 }, () => new Particle(true));
  }

  function tick() {
    ctx.clearRect(0, 0, W, H);
    for (const p of particles) { p.update(); p.draw(); }
    raf = requestAnimationFrame(tick);
  }

  // Pause when tab is hidden to save resources
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) cancelAnimationFrame(raf);
    else tick();
  });

  window.addEventListener('resize', () => { resize(); }, { passive: true });

  init();
  tick();
})();

// === PAGE LOADER ===
window.addEventListener('load', () => {
  const loader = document.querySelector('.page-loader');
  if (loader) setTimeout(() => loader.classList.add('done'), 350);
});

// === SCROLL OBSERVER ===
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in-view'); }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

document.querySelectorAll('.animate, .stagger').forEach(el => observer.observe(el));

// === HEADER ===
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// === BUTTON RIPPLE ===
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn');
  if (!btn) return;
  const r = document.createElement('span');
  const rect = btn.getBoundingClientRect();
  const sz = Math.max(rect.width, rect.height);
  r.className = 'ripple';
  Object.assign(r.style, {
    width: sz + 'px', height: sz + 'px',
    left: (e.clientX - rect.left - sz / 2) + 'px',
    top:  (e.clientY - rect.top  - sz / 2) + 'px'
  });
  btn.appendChild(r);
  r.addEventListener('animationend', () => r.remove());
});

// === CHROME PARTICLE BURST ===
// Appended to document.body with position:fixed — never clipped by button overflow
function burstParticles(originEl) {
  const rect = originEl.getBoundingClientRect();
  const cx   = rect.left + rect.width  / 2;
  const cy   = rect.top  + rect.height / 2;

  // Chrome palette: white core, bright silver, near-white
  const colors = ['#FFFFFF', '#F4F4F4', '#DDDDDD', '#EEEEEE', '#FFFFFF', '#CCCCCC'];
  const count  = 32;

  // 1. Expanding ring flash
  const flash = document.createElement('span');
  flash.className = 'btn-flash';
  flash.style.cssText = `left:${cx}px;top:${cy}px`;
  document.body.appendChild(flash);
  setTimeout(() => flash.remove(), 420);

  // 2. Inner bright flash
  const core = document.createElement('span');
  core.className = 'btn-flash';
  core.style.cssText = `left:${cx}px;top:${cy}px;border-color:rgba(255,255,255,.85);animation-duration:200ms`;
  document.body.appendChild(core);
  setTimeout(() => core.remove(), 250);

  // 3. Spark particles — shoot far outside button
  for (let i = 0; i < count; i++) {
    const angle    = (i / count) * Math.PI * 2 + (Math.random() - .5) * .45;
    const speed    = 90 + Math.random() * 160;   // 90–250px travel
    const size     = 2.5 + Math.random() * 4;
    const duration = 550 + Math.random() * 450;
    const color    = colors[Math.floor(Math.random() * colors.length)];
    const dx       = Math.cos(angle) * speed;
    const dy       = Math.sin(angle) * speed;

    const p = document.createElement('span');
    p.className = 'btn-spark';
    p.style.cssText = [
      `left:${cx}px`, `top:${cy}px`,
      `--pdx:${dx}px`, `--pdy:${dy}px`,
      `--ps:${size}px`, `--pc:${color}`,
      `--pd:${duration}ms`
    ].join(';');
    document.body.appendChild(p);
    setTimeout(() => p.remove(), duration + 60);
  }
}

// Attach burst: Add to Cart, Checkout, cart drawer "Do kasy"
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn-primary');
  if (btn) burstParticles(btn);
});

// === CART STATE ===
let cartOpen = false;
const cartDrawer  = document.querySelector('.cart-drawer');
const cartOverlay = document.querySelector('.cart-overlay');

function openCart()  {
  if (!cartDrawer) return;
  cartOpen = true;
  cartDrawer.classList.add('open');
  cartOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  cartOpen = false;
  cartDrawer?.classList.remove('open');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow = '';
}

cartOverlay?.addEventListener('click', closeCart);
document.querySelector('#cartClose')?.addEventListener('click', closeCart);
document.addEventListener('click', e => {
  if (e.target.closest('.cart-trigger')) { e.preventDefault(); openCart(); }
});

// === CART FETCH / RENDER ===
async function fetchCart() {
  const body = document.querySelector('.cart-drawer-body');
  if (!body) return;
  const res = await fetch('/cart.js').catch(() => null);
  if (!res?.ok) return;
  const cart = await res.json();
  renderDrawer(cart, body);
  updateBadge(cart.item_count);
}

function fmt(cents) {
  return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(cents / 100);
}

function renderDrawer(cart, el) {
  if (!cart.item_count) {
    el.innerHTML = `<div class="cart-empty">
      <p>Koszyk jest pusty</p>
      <a href="/collections/all" class="btn btn-primary">Przeglądaj kolekcję</a>
    </div>`;
    const footer = document.querySelector('.cart-drawer-footer');
    if (footer) footer.style.display = 'none';
    return;
  }
  const footer = document.querySelector('.cart-drawer-footer');
  if (footer) footer.style.display = '';

  el.innerHTML = cart.items.map(item => `
    <div class="drawer-item" data-key="${item.key}">
      <div class="drawer-item__img">
        <img src="${item.image}" alt="${item.product_title}" loading="eager">
      </div>
      <div>
        <p class="drawer-item__name">${item.product_title}</p>
        <div style="display:flex;align-items:center;gap:.9rem;margin-top:.4rem">
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<select class="cart-size-select" data-key="${item.key}" data-handle="${item.handle}" data-qty="${item.quantity}" style="margin-right:0">
                 <option value="${item.variant_id}">${item.variant_title}</option>
               </select>`
            : ''}
          <div class="qty-control">
            <button class="qty-btn" data-action="dec" data-key="${item.key}">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-action="inc" data-key="${item.key}">+</button>
          </div>
        </div>
      </div>
      <div style="text-align:right">
        <p class="price">${fmt(item.final_line_price)}</p>
        <button class="btn-icon" data-remove="${item.key}" aria-label="Usuń" style="margin-top:.25rem">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>
  `).join('');

  // Populate size selects with all available variants
  el.querySelectorAll('.cart-size-select').forEach(async sel => {
    const res = await fetch(`/products/${sel.dataset.handle}.js`).catch(() => null);
    if (!res?.ok) return;
    const prod = await res.json();
    const currentId = parseInt(sel.options[0].value);
    sel.innerHTML = prod.variants.map(v =>
      `<option value="${v.id}" ${v.id === currentId ? 'selected' : ''}>${v.option1}</option>`
    ).join('');
  });

  const tot = document.querySelector('.cart-drawer-total');
  if (tot) tot.innerHTML = `<span>Razem</span><span class="price">${fmt(cart.total_price)}</span>`;
}

// Cart size change — swap variant
document.addEventListener('change', async (e) => {
  const sel = e.target.closest('.cart-size-select');
  if (!sel) return;
  const oldKey  = sel.dataset.key;
  const newId   = parseInt(sel.value);
  const qty     = parseInt(sel.dataset.qty) || 1;
  await fetch('/cart/change.js', {
    method: 'POST', headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: oldKey, quantity: 0})
  });
  await fetch('/cart/add.js', {
    method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({id: newId, quantity: qty})
  });
  fetchCart();
});

function updateBadge(n) {
  document.querySelectorAll('.cart-badge').forEach(el => {
    el.textContent = n;
    el.dataset.count = n;
    el.classList.add('bump');
    setTimeout(() => el.classList.remove('bump'), 350);
  });
}

// Cart qty / remove — optimistic UI + debounce to avoid double requests
const _qtyTimers = {};
document.addEventListener('click', async (e) => {
  const qb = e.target.closest('.qty-btn');
  const rb = e.target.closest('[data-remove]');
  if (qb) {
    const key    = qb.dataset.key;
    const item   = qb.closest('.drawer-item');
    const qtyEl  = item.querySelector('.qty-num');
    const cur    = parseInt(qtyEl.textContent);
    const newQty = qb.dataset.action === 'inc' ? cur + 1 : Math.max(0, cur - 1);
    qtyEl.textContent = newQty;
    clearTimeout(_qtyTimers[key]);
    _qtyTimers[key] = setTimeout(() => changeCart(key, newQty), 350);
  }
  if (rb) await changeCart(rb.dataset.remove, 0);
});

async function changeCart(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).catch(() => null);
  fetchCart();
}

// Add to cart — FormData (same approach as Shopify Horizon/Dawn)
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (form.getAttribute('action') !== '/cart/add' && !form.dataset.productForm) return;
  e.preventDefault();

  const btn      = form.querySelector('[type="submit"]');
  const origText = btn?.textContent;

  // Get or create error message element under button
  let errEl = form.querySelector('.atc-error');
  if (!errEl) {
    errEl = document.createElement('p');
    errEl.className = 'atc-error';
    errEl.style.cssText = 'color:var(--color-accent);font-size:.875rem;margin-top:.75rem;min-height:1.2em;transition:opacity .3s';
    btn?.parentNode?.insertBefore(errEl, btn.nextSibling);
  }
  errEl.textContent = '';

  if (btn) { btn.disabled = true; btn.textContent = 'Dodawanie...'; }

  try {
    // Send as FormData — Shopify accepts this reliably (no JSON conversion issues)
    const formData = new FormData(form);

    const res  = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    const data = await res.json();

    if (!res.ok || data.status) {
      // Show user-visible error under the button
      errEl.textContent = data.description || data.message || 'Nie można dodać do koszyka.';
      setTimeout(() => { errEl.textContent = ''; }, 5000);
    } else {
      openCart();
    }
  } catch (err) {
    errEl.textContent = 'Błąd połączenia — spróbuj ponownie.';
    console.error('[SQUstore]:', err);
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = origText; }
  }
});

// === MOBILE MENU ===
const mobileMenu = document.querySelector('.mobile-menu');
document.querySelector('.mobile-toggle')?.addEventListener('click', () => {
  mobileMenu?.classList.add('open');
  document.body.style.overflow = 'hidden';
});
document.querySelector('.mobile-menu-close')?.addEventListener('click', () => {
  mobileMenu?.classList.remove('open');
  document.body.style.overflow = '';
});

// === PRODUCT GALLERY ===
(function () {
  const wrap = document.getElementById('galleryMain');
  if (!wrap) return;
  const thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  if (!thumbs.length) return;
  let cur = 0;

  // Preload all image srcs upfront for instant switching
  thumbs.forEach(t => {
    const s = t.dataset.src;
    if (s && t.dataset.mediaType !== 'video') { const p = new Image(); p.src = s; }
  });

  function showMedia(idx) {
    idx = (idx + thumbs.length) % thumbs.length;
    cur = idx;
    const thumb = thumbs[idx];
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    if (thumb.dataset.mediaType === 'video') {
      const srcs  = (thumb.dataset.videoSources || '').split('|').filter(Boolean);
      const types = (thumb.dataset.videoTypes   || '').split('|').filter(Boolean);
      const vid = document.createElement('video');
      vid.className = 'gallery-main-img';
      vid.autoplay = true; vid.muted = true; vid.loop = true;
      vid.playsInline = true;
      srcs.forEach((url, i) => {
        const src = document.createElement('source');
        src.src = url; src.type = types[i] || 'video/mp4';
        vid.appendChild(src);
      });
      wrap.innerHTML = '';
      wrap.appendChild(vid);
    } else {
      let img = wrap.querySelector('img.gallery-main-img');
      if (!img) {
        wrap.innerHTML = '';
        img = document.createElement('img');
        img.className = 'gallery-main-img';
        wrap.appendChild(img);
      }
      img.srcset = '';
      img.src = thumb.dataset.src;
    }
  }

  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => showMedia(i));
  });

  document.querySelector('.gallery-arrow--prev')?.addEventListener('click', () => showMedia(cur - 1));
  document.querySelector('.gallery-arrow--next')?.addEventListener('click', () => showMedia(cur + 1));

  document.addEventListener('keydown', e => {
    if (!document.querySelector('.product-gallery')) return;
    if (e.key === 'ArrowLeft')  showMedia(cur - 1);
    if (e.key === 'ArrowRight') showMedia(cur + 1);
  });
})();

// === SIZE SELECTOR ===
(function () {
  const variantsEl = document.getElementById('product-variants-json');
  if (!variantsEl) return;
  const variants = JSON.parse(variantsEl.textContent || '[]');
  const selectedOptions = {};

  // Init from active buttons
  document.querySelectorAll('.size-btn.active').forEach(btn => {
    selectedOptions[btn.dataset.option] = btn.dataset.value;
  });

  function findVariant() {
    return variants.find(v =>
      Object.entries(selectedOptions).every(([pos, val]) => v['option' + pos] === val)
    );
  }

  // Podświetlenie wiersza w rozmiarówce dla wybranego rozmiaru
  function highlightSizeRow(sizeKey) {
    const rows = document.querySelectorAll('.sizeguide-table tbody tr[data-size-key]');
    if (!rows.length) return;
    rows.forEach(row => {
      row.classList.toggle('is-active', !!sizeKey && row.dataset.sizeKey === sizeKey);
    });
  }
  highlightSizeRow(document.querySelector('.size-btn.active[data-size-key]')?.dataset.sizeKey);

  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('size-btn--oos') || btn.disabled) return;
      const pos = btn.dataset.option;
      btn.closest('.size-btns')?.querySelectorAll('.size-btn').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      if (btn.dataset.sizeKey) highlightSizeRow(btn.dataset.sizeKey);
      selectedOptions[pos] = btn.dataset.value;

      // Update option label
      const label = document.getElementById('opt-' + pos + '-val');
      if (label) label.textContent = btn.dataset.value;

      // Update hidden variant input
      const form = btn.closest('form');
      const inp = form?.querySelector('[name="id"]');
      if (inp) {
        const match = findVariant();
        if (match) inp.value = match.id;
      }
    });
  });
})();

// === ESC KEY ===
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  closeCart();
  mobileMenu?.classList.remove('open');
  document.body.style.overflow = '';
});

// === INIT ===
fetchCart();

// Auto-save cart note
(function () {
  const ta = document.getElementById('cart-note');
  const st = document.getElementById('cart-note-status');
  if (!ta) return;
  let timer;
  ta.addEventListener('input', () => {
    clearTimeout(timer);
    if (st) { st.textContent = ''; st.className = 'cart-note-status'; }
    timer = setTimeout(async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: ta.value })
        });
        if (st) { st.textContent = 'Zapisano ✓'; st.className = 'cart-note-status saved'; }
        setTimeout(() => { if (st) { st.textContent = ''; st.className = 'cart-note-status'; } }, 2000);
      } catch (_) {}
    }, 600);
  });
})();

// Populate cart-page size selects (outside drawer)
document.querySelectorAll('.cart-size-select').forEach(async sel => {
  const res = await fetch(`/products/${sel.dataset.handle}.js`).catch(() => null);
  if (!res?.ok) return;
  const prod = await res.json();
  const currentId = parseInt(sel.options[0].value);
  sel.innerHTML = prod.variants.map(v =>
    `<option value="${v.id}" ${v.id === currentId ? 'selected' : ''}>${v.option1}</option>`
  ).join('');
});
